import React, { Component } from 'react';
//import ReactDOM from 'react-dom';
import firebase from './../Firestore'
import { Link } from 'react-router-dom';

import config from 'react-global-configuration';

class NavBar extends Component {

  currentComponent = this;

  constructor() {
    super();
    this.ref = firebase.firestore().collection('pedido').where("enProceso", "==", true).where("estado", "==", "ingresado");
    this.unsubscribe = null;

    this.state = {
      isSignedIn: undefined,
      cantIngresados: undefined
    };
  }

onSignOut(e){
  console.log("entro al onSignOut")
  e.preventDefault()
  firebase.auth().signOut();
  this.props.history.push("/admin/login")
}

async componentDidMount() {

    // Auth

    this.unregisterAuthObserver = await firebase.auth().onAuthStateChanged((user) => {
      this.setState({isSignedIn: !!user});
      if(user){
        let esAdministrador = config.get('admin').indexOf(firebase.auth().currentUser.email);
        if (esAdministrador < 0) this.props.history.push("/admin/login")
      }else{
        this.props.history.push("/admin/login")
      }
    });
    // fin Auth
    this.unsubscribe = await this.ref.onSnapshot(this.onCollectionUpdate);


  }

  componentWillUnmount() {
    this.unregisterAuthObserver(); // Auth
  }


  onCollectionUpdate = (querySnapshot) => {

    this.setState({
      cantIngresados: querySnapshot.size
   });
  }


  render() {

    return (
    <div>
    {this.state.cantIngresados > 0 &&

      <div className="alert alert-warning alert-dismissible fade show d-print-none" role="alert">
        <strong>Hay pedidos nuevos!</strong> Actualiza el estado del pedido para que tu cliente este confiado que su pedido fue recibido.
          {this.props.history.location.pathname !== "/admin/pedidos" &&
            <Link to="/admin/pedidos">Ver los Pedidos</Link>
          }
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    }
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
    <span>Administracion</span>
    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarNavDropdown">
      <ul className="navbar-nav">
        <li className="nav-item">
        <Link to="/admin/pedidos" className="nav-link">Pedidos</Link>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Productos
          </a>
          <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <Link to="/admin" className="dropdown-item">Listado</Link>
            <Link to="/admin/create" className="dropdown-item">Agregar Nuevo</Link>

          </div>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Categorias
          </a>
          <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <Link to="/admin/categoria/lista" className="dropdown-item">Listado</Link>
            <Link to="/admin/categoria/create" className="dropdown-item">Agregar Nueva</Link>
          </div>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Adicionales
          </a>
          <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <Link to="/admin/adicional/lista" className="dropdown-item">Listado</Link>
            <Link to="/admin/adicional/create" className="dropdown-item">Agregar Nuevo</Link>
          </div>
        </li>
      </ul>


      {this.state.isSignedIn &&
            <span className="navbar-text ml-3">Usuario: <strong>{firebase.auth().currentUser.displayName}</strong> | <a href="#" onClick={this.onSignOut}><i className="mt-0 fas fa-sign-out-alt text-primary"></i> Cerrar Sesion</a></span>

      }
      </div>

      </nav>
  </div>


    );
  }

}

export default NavBar;
